module.exports = __webpack_public_path__ + "static/media/StudioC.696855ba.jpg";